import airportList from "./airportsNames.json";
export default {
    nextTicket() {
        return {
            isChange: true,
            GenelBilgileri: {
                HesKodu: null,
                ArkmanUsers: '',
                SirketKodu: '',
                BiletNo: '',
                Formno: '',
                HavaYoluKodu: null,
                UcusTipi: '',
                SiparisNo: 0,
                MusteriKodu: {
                    Kod: '',
                    Uyari: '',
                    BilgiNotu: ''
                },
                KesenKisi: '',
                YolcuAdi: '',
                Parkurlar: {
                    Parkur1: '',
                    Parkur2: '',
                    Parkur3: '',
                    Parkur4: '',
                    Parkur5: '',
                },
                Classlar: {
                    Class1: '',
                    Class2: '',
                    Class3: '',
                    Class4: '',
                    Class5: '',
                },
                FiyatTur: 'AD', //enum deger
                Referans: {
                    Kod: ''
                },
                YolcuAdet: 1,
                Baglantili: false,
                PnrNo: '',
                RezervasyonVeren: '',
                RezervasyonAlan: '',
                Status: null, //enum
                Acente: '',
                AcenteKodu: '',
                ExBiletNo: '',
                ExBiletHY: '',
                ClassTip: 'E', //enum
                BiletYon: 'T', //enum
                DepartmanKod: '',
                Crs: 'Manuel', //enum
                Masraf: {
                    Code: ''
                },
                Email: '',
                BiletTel: '',
            },
            TarihBilgileri: {
                KesimTarihi: null,
                SatisTarihi: null,
                IptalTarihi: null,
                IadeTarihi: null,
                OdemeTarihi: null,
            },
            UcusBilgileri: {
                UcusTarihi: null,
                UcusNo1: null,
                UcusNo2: null,
                UcusDonusTarihi: null,
                UcusDonusNo1: null,
                UcusDonusNo2: null,
                UcusListesi: []
            },
            FaturaBilgileri: {
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: 0,
                EfaturaBilgileri: {
                    FaturaNo: null,
                    Guid: null,
                    FaturaDurumu: null,
                    SanalFaturaNo: null,
                    GercekFaturaNo: null,
                    BasimTarihi: null,
                    Kullanici: null,
                    GonderimSekli: 0,
                    InternetSatis: 0,
                    WebAdresi: null,
                    OdemeSekli: 0,
                    OdemeSekliAciklama: null,
                    OdemeAraci: null,
                    OdemeTarihi: null
                },
                AlisFaturaNo: null,
                ProformaSeri: null,
                ProformaNo: 0,
                ProformaTarihi: null,
                SatisFaturaID: null,
                MaliyetFaturaID: null,
                AlisFaturaTarihi: null,
                AlisFatNo: null,
                FaturaOtomatik: 0,
                IstinaKod: null,
                KdvKod: null,
            },
            TutarBilgileri: {
                Doviz: {
                    DovizKod: ''
                },
                Kur: 1,
                NetTutar: {
                    NetTutar: 0,
                    NetTutarSatisDoviz: 0,
                    NetTutarAlisDoviz: 0,
                    NetTutarKdv: 0,
                },
                Tutar: {
                    Tutar: 0,
                    TutarSatisDoviz: 0,
                    TutarAlisDoviz: 0,
                    TutarKdv: 0,
                },
                PtaTutar: {
                    PtaTutar: 0,
                    PtaSatisDoviz: 0,
                    PtaAlisDoviz: 0,
                    PtaKdv: 0
                },
                AlanVergiTutar: {
                    AlanVergiTutar: 0,
                    AlanVergiSatisDoviz: 0,
                    AlanVergiAlisDoviz: 0,
                    AlanVergiKdv: 0,
                },
                CharterTutar: {
                    CharterTutar: 0,
                    CharterSatisDoviz: 0,
                    CharterAlisDoviz: 0,
                    CharterKdv: 0
                },
                YFFTutar: {
                    YFFTutar: 0,
                    YFFDoviz: 0,
                    YFFKdv: 0
                },
                ServisTutar: {
                    ServisTutar: 0,
                    ServisDoviz: 0,
                    ServisKdv: 0
                },
                DigerServisTutar: {
                    DigerServisTutar: 0,
                    DigerServisDoviz: 0,
                    DigerServisKdv: 0
                },
                IskontoTutar: {
                    IskontoYuzde: 0,
                    IskontoTutar: 0,
                    IskontoDoviz: 0,
                    IskontoKdv: 0
                },
                TaxTutar: {
                    TaxTutar: 0,
                    TaxSatisDoviz: 0,
                    TaxAlisDoviz: 0,
                    TaxKdv: 0
                },
                CezaTutar: {
                    CezaTutar: 0,
                    CezaSatisTutar: 0,
                    CezaAlisTutar: 0,
                    CezaKdv: 0
                },
                KaTutar: {
                    KaTutar: 0,
                    KaDoviz: 0,
                    KaKdv: 0
                },
                ReserveTutar: {
                    ReserveYuzde: 0,
                    ReserveTutar: 0,
                    ReserveDoviz: 0,
                    ReserveKdv: 0
                }
            },
            OdemeBilgileri: {
                SatisSekli: 'K', //enum
                KomisyonTip: '', //enum
                HYOran: 0,
                GSAOran: 0,
                KrediliTutar: 0,
                KrediliDoviz: 0,
                PesinTutar: 0,
                PesinDoviz: 0,
                KrediKartTutar: 0,
                KrediKartDoviz: 0,
                KrediKartBilgi: {
                    KrediKartNo: '',
                    KrediKartAy: '',
                    KrediKartYil: '',
                    KrediKartCins: '',
                    KrediKartTip: ''
                },
                AlisServisTutar: {
                    AlisServisTutar: 0,
                    AlisServisDoviz: 0,
                    AlisServisKdv: 0
                },
                HavaYoluTutar: 0,
                HavaYoluKdv: 0,
                Csc: false,
                BankaBilgileri: {
                    PosKod: {
                        BankaPosID: 0,
                        SirketKodu: 0,
                        PosKodu: '',
                        Aciklama: '',
                        MuhasebeKodlar: {
                            MuhasebeKodu: '',
                            CMuhasebeKodu: '',
                            FDisAktarimCariKodu: '',
                            FDisAktarimMuhKodu: '',
                            CDisAktarimCariKodu: '',
                            CDisAktarimMuhKodu: '',
                            ServisMuhasebeKodu: '',
                            ServisDisAktarimCariKodu: '',
                            ServisDisAktarimMuhKodu: ''
                        },
                        Parametreler: {
                            ID: 0,
                            Banka: {
                                BankaID: 0,
                                SirketKodu: 0,
                                BankaKod: '',
                                BankaAdi: '',
                                Cari: {
                                    Kod: ''
                                },
                                BankaKisaKod: '',
                                Tip: 0
                            },
                            PosMuhKodu: '',
                            PuanCariKodu: '',
                            SozlesmeBaslangic: null,
                            SozlesmeBitis: null,
                            Aktif: '',
                            VadeTip: '',
                            UyelikTutar: 0,
                            UyelikOran: 0,
                            Kota: 0,
                            KotaGun: 0,
                            KotaCezaTutar: 0,
                            KotaCezaOran: 0,
                            VadeSabitGun: 0,
                            VadeFarkSabit: 0,
                            KotaKod: '',
                            TerminalID: '',
                            UyeIsYeriID: '',
                            UserName: '',
                            UserPass: '',
                            PosType: 0,
                            StoreKey: '',
                        }
                        //public List<BankaPosTaksit> Taksitler { get; set; }
                    },
                    ServisPosKod: {
                        BankaPosID: 0,
                        SirketKodu: 0,
                        PosKodu: '',
                        Aciklama: '',
                        MuhasebeKodlar: {
                            MuhasebeKodu: '',
                            CMuhasebeKodu: '',
                            FDisAktarimCariKodu: '',
                            FDisAktarimMuhKodu: '',
                            CDisAktarimCariKodu: '',
                            CDisAktarimMuhKodu: '',
                            ServisMuhasebeKodu: '',
                            ServisDisAktarimCariKodu: '',
                            ServisDisAktarimMuhKodu: ''
                        },
                        Parametreler: {
                            ID: 0,
                            Banka: {
                                BankaID: 0,
                                SirketKodu: 0,
                                BankaKod: '',
                                BankaAdi: '',
                                Cari: {
                                    Kod: ''
                                },
                                BankaKisaKod: '',
                                Tip: 0
                            },
                            PosMuhKodu: '',
                            PuanCariKodu: '',
                            SozlesmeBaslangic: null,
                            SozlesmeBitis: null,
                            Aktif: '',
                            VadeTip: '',
                            UyelikTutar: 0,
                            UyelikOran: 0,
                            Kota: 0,
                            KotaGun: 0,
                            KotaCezaTutar: 0,
                            KotaCezaOran: 0,
                            VadeSabitGun: 0,
                            VadeFarkSabit: 0,
                            KotaKod: '',
                            TerminalID: '',
                            UyeIsYeriID: '',
                            UserName: '',
                            UserPass: '',
                            PosType: 0,
                            StoreKey: '',
                        },
                        Taksitler: []
                    },

                    ServisPosTutar: 0,
                    TaksitKod: '',
                    ServisTaksitKod: '',
                    TaksitKodLabel: '',
                    ServisTaksitKodLabel: '',
                    PuanTutar: 0
                },
                Slipkod: '',
                MakbuzNo: '',
            },
            DigerBilgileri: {
                SaveTime: null,
                Entegre: false,
                BiletTanim: '',
                eservedTutar1: 0,
                ExIcDis: '',
                EntegreTablo: '',
                GrossTutar: 0,
                CharterPtaKodu: '',
                pArkmanEntegre: '',
                PinKodu: '',
                RezervasyonID: '',
                SiparisID: '',
                CKLogID: 0,
                ParkurTip: '',
                DServisKod1: '',
                DServisKod2: '',
                KKEnt: '',
                SatisSapEntegre: '',
                MaliyetSapEntegre: '',
                KisiID: 0,
                // EntegrasyonID: guid değişkeni
                UserID: 0,
            },
            TanimBilgileri: {
                ServisKod: '',
                AnalizKod: {
                    SirketKodu: 0,
                    AnalizKod: '',
                    AnalizAdi: '',
                    AnalizTutar: 0,
                    AnalizOran: 0,
                },
                AnalizTutar: 0,
                AnalizDoviz: 0,
                AnalizKod1: {
                    SirketKodu: 0,
                    AnalizKod: '',
                    AnalizAdi: '',
                    AnalizTutar: 0,
                    AnalizOran: 0,
                },
                AnalizTutar1: 0,
                AnalizDoviz1: 0,
                TcKimlikNolar: {
                    TcNo1: '',
                    TcNo2: '',
                    TcNo3: '',
                    TcNo4: '',
                    TcNo5: ''
                },
                Aciklamalar: {
                    Aciklama1: '',
                    Aciklama2: '',
                    Aciklama3: '',
                    Aciklama4: '',
                    Aciklama5: '',
                    Aciklama6: '',
                    Aciklama7: '',
                },
                MilKodu: {
                    MilKoduOde: '',
                    MilKoduYolcu: '',
                    MilAdet: 0,
                    MilTutar: 0
                },
                MusteriPersonel: {
                    PersonelUcan: {
                        ID: 0,
                        SirketKodu: 0,
                        SirketAdi: '',
                        MasrafYeri: '',
                        SicilNo: '',
                        Adi: '',
                        Soyadi: '',
                        CalismaYeri: '',
                        Bolum: '',
                        IcSeyahat: '',
                        DisSeyahat: '',
                        IsAlani: '',
                        Siparis: '',
                        Cari: {
                            Kod: ''
                        },
                        KapatAc: false,
                        Email: '',
                        Tel: ''
                    },
                    PersonelSponsor: {
                        ID: 0,
                        SirketKodu: 0,
                        SirketAdi: '',
                        MasrafYeri: '',
                        SicilNo: '',
                        Adi: '',
                        Soyadi: '',
                        CalismaYeri: '',
                        Bolum: '',
                        IcSeyahat: '',
                        DisSeyahat: '',
                        IsAlani: '',
                        Siparis: '',
                        Cari: {
                            Kod: ''
                        },
                        KapatAc: false,
                        Email: '',
                        Tel: ''
                    }
                },
                YolcuCrm: {
                    CrmYolcu: {
                        Ref: 0,
                        Adi: '',
                        Soyadi: '',
                        Tel: '',
                        Gsm: '',
                        Email: '',
                        TCKimlikNo: '',
                        ID: 0
                    },
                    CrmRezervasyon: {
                        Ref: 0,
                        Adi: '',
                        Soyadi: '',
                        Tel: '',
                        Gsm: '',
                        Email: '',
                        TCKimlikNo: '',
                        ID: 0
                    }
                },
                ProfilID: 0,
                SablonID: 0,
                Bolum: '',
                EventID: '',
                ExAciklamalar: {
                    ID: 0,
                    SirketKodu: 0,
                    Biletno: '',
                    HavayoluKod: '',
                    EmployeeId: '',
                    DepartmentId: '',
                    CostCenter: '',
                    ClientId: '',
                    DkNumber: '',
                    WwId: '',
                    BusinessUnit: '',
                    CompanyCode: '',
                    SiteCode: '',
                    PurposeOt: '',
                    PcNumber: '',
                    NoHotelBc: '',
                    TripApprover: ''
                }
            },
            AyrintiOdemeBilgileri: [],
            NotlarBilgileri: {
                SirketKodu: 0,
                BiletNo: '',
                FormNo: '',
                Aciklama1: '',
                Aciklama2: '',
                Segment1: '',
                Segment2: '',
                Segment3: '',
                Segment4: '',
                Segment5: '',
                RefFare: 0,
                LowFare: 0,
                RealCode: '',
                DateofRes: null,
                MarketCode: '',
                TicketSuffix: '',
                VendorNumber: '',
                ReasonCode: '',
                CRSGDS: '',
                SubPruductCode: '',
                TicketTypeInd: false,
                TourCode: '',
                AlternatifTutar1: 0,
                AlternatifTutar2: 0,
                AlternatifTutar3: 0,
                Anlasmali: false,
                Esnek: false,
                KarbonSalinimi: 0,
                Mil1: 0,
                Mil2: 0,
                Mil3: 0,
                Mil4: 0
            },

            TaksitBilgileri: {
                ID: 0,
                SirketKodu: 0,
                BiletNo: '',
                HavaYoluKodu: '',
                MakbuzNo: '',
                CCNo1: '',
                Tip1: '',
                Ay1: 0,
                Yil1: 0,
                Tutar1: 0,
                Iade1: 0,
                Taksit1: 0,
                TVade1: null,
                PosKodu1: '',
                CCNo2: '',
                Tip2: '',
                Ay2: 0,
                Yil2: 0,
                Tutar2: 0,
                Iade2: 0,
                Taksit2: 0,
                TVade2: null,
                PosKodu2: '',
                CCNo3: '',
                Tip3: '',
                Ay3: 0,
                Yil3: 0,
                Tutar3: 0,
                Iade3: 0,
                Taksit3: 0,
                TVade3: null,
                PosKodu3: '',
                CCNo4: '',
                Tip4: '',
                Ay4: 0,
                Yil4: 0,
                Tutar4: 0,
                Iade4: 0,
                Taksit4: 0,
                TVade4: null,
                PosKodu4: '',
                PesinSatisTutari: 0,
                PesinIadeTutari: 0,
                SlipKod1: '',
                SlipKod2: '',
                SlipKod3: '',
                SlipKod4: '',
                OdemeFaturaId: '',
                OdemeSapEntegre: '',
            }
        }
    },

    makePayment() {
        return {
            Id: "",
            IpAddress: "",
            SessionHeader: {
                SessionId: "",
                SessionToken: ""
            },
            ShoppingCartId: "",
            Amount: 0,
            PaymentType: "CurrentPayment",
        }
    },
    billingInformation() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            BillingInformation: {
                IfCompany: true,
                IfCurrentCodeSet: true,
                BillingName: "",
                TaxOffice: "",
                TaxNo: "",
                City: "",
                District: "",
                ZipCode: "",
                CountryCode: "",
                Address: "",
                AutoBill: true,
                ServiceFee: 0
            }
        }
    },
    finalizeShopping() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            LinkUrl: "",
            SendInformationEmails: true,
        }
    },
    makePrebooking() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            LinkUrl: null,
            SelectedServiceFee: 0.0,
            ContinueWithoutReservation: false,
        }
    },
    updatePassengers() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            ShoppingCartId: null,
            CorporatePin: "",
            Contact: {
                Name: null,
                LastName: null,
                Phone: null,
                Email: null
            },
            Passengers: [],
            EArchiveWebAddress: 0,
            Notes: null,
        }
    },
    contact() {
        return {
            Name: null,
            LastName: null,
            Phone: null,
            Email: null
        }
    },
    passenger() {
        return {
            FirstName: "",
            LastName: "",
            PaxType: "",
            Gender: "",
            BirthDate: null,
            Email: "",
            Phone: "",
            CitizenNo: "",
            PassportNo: "",
            PassportExpireDate: null,
            Nationality: "",
            HesCode: "",
            FrequentFlayerNo: "",
            WheelChairService: "0",
            PaxReferanceId: "",
            ExtraPosAmount: "",
            HasTicket: false
        }
    },
    passengerType: function (val) {
        var passengerType = null;
        switch (val) {
            case "ADT":
                passengerType = "Yetiskin";
                break;
            case "CHD":
                passengerType = "Cocuk";
                break;
            case "INF":
                passengerType = "Bebek";
                break;
            case "SRC":
                passengerType = "+65 Yas";
                break;
            case "STD":
                passengerType = "Ogrenci";
                break;
            case "MIL":
                passengerType = "Asker";
                break;

            default:
                break;
        }
        return passengerType
    },

    wheelChairs() {
        return [{
            text: 'Tekerlekli sandalye istenmiyor',
            value: 0
        },
        {
            text: 'Kabinde koltuğua kadar',
            value: 1
        },
        {
            text: 'Aprondan uçağa kadar',
            value: 2
        },
        {
            text: 'Basamaklar için',
            value: 3
        }
        ]
    },

    allocateItems() {
        return {
            ProductId: null,
            FareCode: null,
            MarkupFare: 0,
            SetServiceFare: 0
        }
    },
    allocateParams() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null
            },
            AllocateItems: [
            ],
            CreateShoppingCart: true,
            IncludeBags: false,
            IncludedBags: {
                ShoppingCartId: null,
                List: []
            }
        }
    },
    nextSearchParams() {
        return {
            Departure: null,
            Destination: null,
            DepartureDay: null,
            DestinationDay: null,
            OneWay: true,
            RoundTrip: false,
            Adult: 1,
            Child: 0,
            Baby: 0,
            Student: 0,
            Young: 0,
            Old: 0,
            Soldier: 0,
            Accouting: null,
            Cabin: "Economy",
            Markup: 0,
            FlightType: 'OW'
        }
    },
    bookingSearchParams() {
        return {
            SessionHeader: {
                SessionId: null,
                SessionToken: null,
            },
            AirSearchOptions: {
                FlightType: null, //    NONE, OW(ONEWAY),RT,MULTI
                CabinType: null,
                CabinTypeOptions: [

                ],
                RefundableType: "AllFlights",
                Currency: "TRY",
                FareDisplayType: "Lowest",
                PreferedAirlines: [],
                MarkupFareList: 0,
                CompanyCode: null,
                DirectFlightsOnly: false,
                AvailableFlightsOnly: true,
                SelectableFaresOnly: true,
            },
            AirSearchPaxItems: [],
            AirSearchSegments: [],
        }
    },

    AirSearchSegments() {
        return {
            SequenceNo: 0,
            DepartureDay: null,
            Origin: {
                AirportCode: null,
                IsCity: false,
            },
            Destination: {
                AirportCode: null,
                IsCity: false,
            },
        }
    },

    CabinTypeOptions() {
        return {
            Airline: null,
            IncludeBusinessClass: true,
        }
    },

    AirSearchPaxItems() {
        return {
            PaxCode: null,
            PaxCount: 0,
        }
    },

    Genders() {
        return [
            {
                text: 'Bay',
                value: 'Male'
            },
            {
                text: 'Bayan',
                value: 'Female'
            }
        ]
    },

    headersFlightInfoSummary() {
        return [
            {
                text: "Tip",
                sortable: false,
                width: "1px",

            },
            {
                text: "Net",
                sortable: false,
                width: "1%"
            },
            {
                text: "Vergi",
                sortable: false,
                width: "1%"
            },
            {
                text: "Servis",
                sortable: false,
                width: "1%"
            },
            {
                text: "Vade",
                sortable: false,
                width: "1%"
            },
            {
                text: "Markup",
                sortable: false,
                width: "1%"
            },
            {
                text: "L.Markup",
                sortable: false,
                width: "1%"
            },
            {
                text: "Toplam",
                sortable: false,
                width: "1%"
            },
            {
                text: "Para Birimi",
                sortable: false,
                width: "1%"
            },
        ]
    },

    headersSummary() {
        return [
            {
                text: "Tip",
                sortable: false,
            },
            {
                text: "Net",
                sortable: false,
            },
            {
                text: "Vergi",
                sortable: false,
            },
            {
                text: "Sistem Servis Bedeli",
                sortable: false,
            },
            {
                text: "Yolcu",
                sortable: false,
            },
            {
                text: "Bagaj",
                sortable: false,
            },
            {
                text: "Toplam",
                sortable: false,
            },
        ]
    },

    countiries() {
        return [
            {
                name: "Peru",
                currency: "PEN",
                code: "PE",
                name_translations: {
                    en: "Peru"
                }
            },
            {
                name: "Belize",
                currency: "BZD",
                code: "BZ",
                name_translations: {
                    en: "Belize"
                }
            },
            {
                name: "Saint Pierre ve Miquelon",
                currency: "EUR",
                code: "PM",
                name_translations: {
                    en: "Saint Pierre and Miquelon"
                }
            },
            {
                name: "Somali",
                currency: "SOS",
                code: "SO",
                name_translations: {
                    en: "Somalia"
                }
            },
            {
                name: "Bouvet Island",
                currency: "NOK",
                code: "BV",
                name_translations: {
                    en: "Bouvet Island"
                }
            },
            {
                name: "Panama",
                currency: "PAB",
                code: "PA",
                name_translations: {
                    en: "Panama"
                }
            },
            {
                name: "Kongo - Brazavil",
                currency: "XAF",
                code: "CG",
                name_translations: {
                    en: "Republic of the Congo"
                }
            },
            {
                name: "Filipinler",
                currency: "PHP",
                code: "PH",
                name_translations: {
                    en: "Philippines"
                }
            },
            {
                name: "Gana",
                currency: "GHS",
                code: "GH",
                name_translations: {
                    en: "Ghana"
                }
            },
            {
                name: "İspanya",
                currency: "EUR",
                code: "ES",
                name_translations: {
                    en: "Spain"
                }
            },
            {
                name: "Grenada",
                currency: "XCD",
                code: "GD",
                name_translations: {
                    en: "Grenada"
                }
            },
            {
                name: "Mozambik",
                currency: "MZN",
                code: "MZ",
                name_translations: {
                    en: "Mozambique"
                }
            },
            {
                name: "Falkland Adaları",
                currency: "FKP",
                code: "FK",
                name_translations: {
                    en: "Falkland Islands"
                }
            },
            {
                name: "Samoa",
                currency: "WST",
                code: "WS",
                name_translations: {
                    en: "Samoa"
                }
            },
            {
                name: "Cocos (Keeling) Adaları",
                currency: "AUD",
                code: "CC",
                name_translations: {
                    en: "Cocos (Keeling) Islands"
                }
            },
            {
                name: "Yeni Kaledonya",
                currency: "XPF",
                code: "NC",
                name_translations: {
                    en: "New Caledonia"
                }
            },
            {
                name: "Güney Kore",
                currency: "KRW",
                code: "KR",
                name_translations: {
                    en: "South Korea"
                }
            },
            {
                name: "Fildişi Sahili",
                currency: "XOF",
                code: "CI",
                name_translations: {
                    en: "Ivory Coast"
                }
            },
            {
                name: "Curaçao",
                currency: "ANG",
                code: "CW",
                name_translations: {
                    en: "Curaçao"
                }
            },
            {
                name: "Paraguay",
                currency: "PYG",
                code: "PY",
                name_translations: {
                    en: "Paraguay"
                }
            },
            {
                name: "Komorlar",
                currency: "KMF",
                code: "KM",
                name_translations: {
                    en: "Comoros"
                }
            },
            {
                name: "Jamaika",
                currency: "JMD",
                code: "JM",
                name_translations: {
                    en: "Jamaica"
                }
            },
            {
                name: "Malta",
                currency: "EUR",
                code: "MT",
                name_translations: {
                    en: "Malta"
                }
            },
            {
                name: "Cayman Adaları",
                currency: "KYD",
                code: "KY",
                name_translations: {
                    en: "Cayman Islands"
                }
            },
            {
                name: "Antarktika",
                currency: null,
                code: "AQ",
                name_translations: {
                    en: "Antarctica"
                }
            },
            {
                name: "Saint Barthelemy",
                currency: "EUR",
                code: "BL",
                name_translations: {
                    en: "Saint Barthélemy"
                }
            },
            {
                name: "Andorra",
                currency: "EUR",
                code: "AD",
                name_translations: {
                    en: "Andorra"
                }
            },
            {
                name: "Birleşik Arap Emirlikleri",
                currency: "AED",
                code: "AE",
                name_translations: {
                    en: "United Arab Emirates"
                }
            },
            {
                name: "Guadalupe",
                currency: "EUR",
                code: "GP",
                name_translations: {
                    en: "Guadeloupe"
                }
            },
            {
                name: "Kuzey Mariana Adaları",
                currency: "USD",
                code: "MP",
                name_translations: {
                    en: "Northern Mariana Islands"
                }
            },
            {
                name: "Western Sahara",
                currency: "MAD",
                code: "EH",
                name_translations: {
                    en: "Western Sahara"
                }
            },
            {
                name: "Çek Cumhuriyeti",
                currency: "CZK",
                code: "CZ",
                name_translations: {
                    en: "Czech Republic"
                }
            },
            {
                name: "Nauru",
                currency: "AUD",
                code: "NR",
                name_translations: {
                    en: "Nauru"
                }
            },
            {
                name: "ABD Virjin Adaları",
                currency: "USD",
                code: "VI",
                name_translations: {
                    en: "U.S. Virgin Islands"
                }
            },
            {
                name: "Mali",
                currency: "XOF",
                code: "ML",
                name_translations: {
                    en: "Mali"
                }
            },
            {
                name: "Brezilya",
                currency: "BRL",
                code: "BR",
                name_translations: {
                    en: "Brazil"
                }
            },
            {
                name: "Cibuti",
                currency: "DJF",
                code: "DJ",
                name_translations: {
                    en: "Djibouti"
                }
            },
            {
                name: "Haiti",
                currency: "HTG",
                code: "HT",
                name_translations: {
                    en: "Haiti"
                }
            },
            {
                name: "Estonya",
                currency: "EUR",
                code: "EE",
                name_translations: {
                    en: "Estonia"
                }
            },
            {
                name: "Liechtenstein",
                currency: "CHF",
                code: "LI",
                name_translations: {
                    en: "Liechtenstein"
                }
            },
            {
                name: "Butan",
                currency: "BTN",
                code: "BT",
                name_translations: {
                    en: "Bhutan"
                }
            },
            {
                name: "Gine",
                currency: "GNF",
                code: "GN",
                name_translations: {
                    en: "Guinea"
                }
            },
            {
                name: "Etiyopya",
                currency: "ETB",
                code: "ET",
                name_translations: {
                    en: "Ethiopia"
                }
            },
            {
                name: "Guatemala",
                currency: "GTQ",
                code: "GT",
                name_translations: {
                    en: "Guatemala"
                }
            },
            {
                name: "Eritre",
                currency: "ERN",
                code: "ER",
                name_translations: {
                    en: "Eritrea"
                }
            },
            {
                name: "Lesoto",
                currency: "LSL",
                code: "LS",
                name_translations: {
                    en: "Lesotho"
                }
            },
            {
                name: "Porto Riko",
                currency: "USD",
                code: "PR",
                name_translations: {
                    en: "Puerto Rico"
                }
            },
            {
                name: "Lübnan",
                currency: "LBP",
                code: "LB",
                name_translations: {
                    en: "Lebanon"
                }
            },
            {
                name: "Lüksemburg",
                currency: "EUR",
                code: "LU",
                name_translations: {
                    en: "Luxembourg"
                }
            },
            {
                name: "Faroe Adaları",
                currency: "DKK",
                code: "FO",
                name_translations: {
                    en: "Faroe Islands"
                }
            },
            {
                name: "Saint Vincent ve Grenadinler",
                currency: "XCD",
                code: "VC",
                name_translations: {
                    en: "Saint Vincent and the Grenadines"
                }
            },
            {
                name: "Moldova",
                currency: "MDL",
                code: "MD",
                name_translations: {
                    en: "Moldova"
                }
            },
            {
                name: "Kıbrıs",
                currency: "EUR",
                code: "CY",
                name_translations: {
                    en: "Cyprus"
                }
            },
            {
                name: "Katar",
                currency: "QAR",
                code: "QA",
                name_translations: {
                    en: "Qatar"
                }
            },
            {
                name: "Norfolk Adası",
                currency: "AUD",
                code: "NF",
                name_translations: {
                    en: "Norfolk Island"
                }
            },
            {
                name: "Karadağ",
                currency: "EUR",
                code: "ME",
                name_translations: {
                    en: "Montenegro"
                }
            },
            {
                name: "Mauritius",
                currency: "MUR",
                code: "MU",
                name_translations: {
                    en: "Mauritius"
                }
            },
            {
                name: "Tunus",
                currency: "TND",
                code: "TN",
                name_translations: {
                    en: "Tunisia"
                }
            },
            {
                name: "Dominika",
                currency: "XCD",
                code: "DM",
                name_translations: {
                    en: "Dominica"
                }
            },
            {
                name: "Birleşik Krallık",
                currency: "GBP",
                code: "GB",
                name_translations: {
                    en: "United Kingdom"
                }
            },
            {
                name: "Şili",
                currency: "CLP",
                code: "CL",
                name_translations: {
                    en: "Chile"
                }
            },
            {
                name: "Sierra Leone",
                currency: "SLL",
                code: "SL",
                name_translations: {
                    en: "Sierra Leone"
                }
            },
            {
                name: "Fransız Polinezyası",
                currency: "XPF",
                code: "PF",
                name_translations: {
                    en: "French Polynesia"
                }
            },
            {
                name: "Cook Adaları",
                currency: "NZD",
                code: "CK",
                name_translations: {
                    en: "Cook Islands"
                }
            },
            {
                name: "Myanmar (Burma)",
                currency: "MMK",
                code: "MM",
                name_translations: {
                    en: "Myanmar"
                }
            },
            {
                name: "Ruanda",
                currency: "RWF",
                code: "RW",
                name_translations: {
                    en: "Rwanda"
                }
            },
            {
                name: "Singapur",
                currency: "SGD",
                code: "SG",
                name_translations: {
                    en: "Singapore"
                }
            },
            {
                name: "Pitcairn Islands",
                currency: "NZD",
                code: "PN",
                name_translations: {
                    en: "Pitcairn Islands"
                }
            },
            {
                name: "Monako",
                currency: "EUR",
                code: "MC",
                name_translations: {
                    en: "Monaco"
                }
            },
            {
                name: "Makedonya",
                currency: "MKD",
                code: "MK",
                name_translations: {
                    en: "North Macedonia"
                }
            },
            {
                name: "Suudi Arabistan",
                currency: "SAR",
                code: "SA",
                name_translations: {
                    en: "Saudi Arabia"
                }
            },
            {
                name: "Ermenistan",
                currency: "AMD",
                code: "AM",
                name_translations: {
                    en: "Armenia"
                }
            },
            {
                name: "İsveç",
                currency: "SEK",
                code: "SE",
                name_translations: {
                    en: "Sweden"
                }
            },
            {
                name: "Brunei",
                currency: "BND",
                code: "BN",
                name_translations: {
                    en: "Brunei"
                }
            },
            {
                name: "Tokelau",
                currency: "NZD",
                code: "TK",
                name_translations: {
                    en: "Tokelau"
                }
            },
            {
                name: "Réunion",
                currency: "EUR",
                code: "RE",
                name_translations: {
                    en: "Réunion"
                }
            },
            {
                name: "İrlanda",
                currency: "EUR",
                code: "IE",
                name_translations: {
                    en: "Ireland"
                }
            },
            {
                name: "Nijerya",
                currency: "NGN",
                code: "NG",
                name_translations: {
                    en: "Nigeria"
                }
            },
            {
                name: "Åland Adaları",
                currency: "EUR",
                code: "AX",
                name_translations: {
                    en: "Åland Islands"
                }
            },
            {
                name: "Svalbard ve Jan Mayen Adaları",
                currency: "NOK",
                code: "SJ",
                name_translations: {
                    en: "Svalbard and Jan Mayen"
                }
            },
            {
                name: "Slovenya",
                currency: "EUR",
                code: "SI",
                name_translations: {
                    en: "Slovenia"
                }
            },
            {
                name: "Montserrat",
                currency: "XCD",
                code: "MS",
                name_translations: {
                    en: "Montserrat"
                }
            },
            {
                name: "Mayotte",
                currency: "EUR",
                code: "YT",
                name_translations: {
                    en: "Mayotte"
                }
            },
            {
                name: "Turks ve Caicos Adaları",
                currency: "USD",
                code: "TC",
                name_translations: {
                    en: "Turks and Caicos Islands"
                }
            },
            {
                name: "Kongo - Kinşasa",
                currency: "CDF",
                code: "CD",
                name_translations: {
                    en: "Democratic Republic of the Congo"
                }
            },
            {
                name: "Macaristan",
                currency: "HUF",
                code: "HU",
                name_translations: {
                    en: "Hungary"
                }
            },
            {
                name: "Çin",
                currency: "CNY",
                code: "CN",
                name_translations: {
                    en: "China"
                }
            },
            {
                name: "Martinik",
                currency: "EUR",
                code: "MQ",
                name_translations: {
                    en: "Martinique"
                }
            },
            {
                name: "Amerikan Samoası",
                currency: "USD",
                code: "AS",
                name_translations: {
                    en: "American Samoa"
                }
            },
            {
                name: "Saint Kitts ve Nevis",
                currency: "XCD",
                code: "KN",
                name_translations: {
                    en: "Saint Kitts and Nevis"
                }
            },
            {
                name: "Saint Helena, Ascension and Tristan da Cunha",
                currency: "SHP",
                code: "SH",
                name_translations: {
                    en: "Saint Helena, Ascension and Tristan da Cunha"
                }
            },
            {
                name: "Beyaz Rusya",
                currency: "BYR",
                code: "BY",
                name_translations: {
                    en: "Belarus"
                }
            },
            {
                name: "Tuvalu",
                currency: "AUD",
                code: "TV",
                name_translations: {
                    en: "Tuvalu"
                }
            },
            {
                name: "Ekvador",
                currency: "USD",
                code: "EC",
                name_translations: {
                    en: "Ecuador"
                }
            },
            {
                name: "British Indian Ocean Territory",
                currency: "USD",
                code: "IO",
                name_translations: {
                    en: "British Indian Ocean Territory"
                }
            },
            {
                name: "Guyana",
                currency: "GYD",
                code: "GY",
                name_translations: {
                    en: "Guyana"
                }
            },
            {
                name: "Pakistan",
                currency: "PKR",
                code: "PK",
                name_translations: {
                    en: "Pakistan"
                }
            },
            {
                name: "Cebelitarık",
                currency: "GIP",
                code: "GI",
                name_translations: {
                    en: "Gibraltar"
                }
            },
            {
                name: "Antigua ve Barbuda",
                currency: "XCD",
                code: "AG",
                name_translations: {
                    en: "Antigua and Barbuda"
                }
            },
            {
                name: "Niue",
                currency: "NZD",
                code: "NU",
                name_translations: {
                    en: "Niue"
                }
            },
            {
                name: "Cape Verde",
                currency: "CVE",
                code: "CV",
                name_translations: {
                    en: "Cape Verde"
                }
            },
            {
                name: "Botsvana",
                currency: "BWP",
                code: "BW",
                name_translations: {
                    en: "Botswana"
                }
            },
            {
                name: "Grönland",
                currency: "DKK",
                code: "GL",
                name_translations: {
                    en: "Greenland"
                }
            },
            {
                name: "Kosta Rika",
                currency: "CRC",
                code: "CR",
                name_translations: {
                    en: "Costa Rica"
                }
            },
            {
                name: "Afganistan",
                currency: "AFN",
                code: "AF",
                name_translations: {
                    en: "Afghanistan"
                }
            },
            {
                name: "Hong Kong",
                currency: "HKD",
                code: "HK",
                name_translations: {
                    en: "Hong Kong"
                }
            },
            {
                name: "Azerbaycan",
                currency: "AZN",
                code: "AZ",
                name_translations: {
                    en: "Azerbaijan"
                }
            },
            {
                name: "Küba",
                currency: "CUP",
                code: "CU",
                name_translations: {
                    en: "Cuba"
                }
            },
            {
                name: "Sırbistan",
                currency: "RSD",
                code: "RS",
                name_translations: {
                    en: "Serbia"
                }
            },
            {
                name: "Finlandiya",
                currency: "EUR",
                code: "FI",
                name_translations: {
                    en: "Finland"
                }
            },
            {
                name: "Solomon Adaları",
                currency: "SBD",
                code: "SB",
                name_translations: {
                    en: "Solomon Islands"
                }
            },
            {
                name: "Vietnam",
                currency: "VND",
                code: "VN",
                name_translations: {
                    en: "Vietnam"
                }
            },
            {
                name: "Zimbabve",
                currency: "ZWD",
                code: "ZW",
                name_translations: {
                    en: "Zimbabwe"
                }
            },
            {
                name: "Jersey",
                currency: "GBP",
                code: "JE",
                name_translations: {
                    en: "Jersey"
                }
            },
            {
                name: "Heard Island and McDonald Islands",
                currency: "AUD",
                code: "HM",
                name_translations: {
                    en: "Heard Island and McDonald Islands"
                }
            },
            {
                name: "Barbados",
                currency: "BBD",
                code: "BB",
                name_translations: {
                    en: "Barbados"
                }
            },
            {
                name: "Gabon",
                currency: "XAF",
                code: "GA",
                name_translations: {
                    en: "Gabon"
                }
            },
            {
                name: "Rusya",
                currency: "RUB",
                code: "RU",
                name_translations: {
                    en: "Russia"
                }
            },
            {
                name: "Kolombiya",
                currency: "COP",
                code: "CO",
                name_translations: {
                    en: "Colombia"
                }
            },
            {
                name: "Dominik Cumhuriyeti",
                currency: "DOP",
                code: "DO",
                name_translations: {
                    en: "Dominican Republic"
                }
            },
            {
                name: "Guernsey",
                currency: "GBP",
                code: "GG",
                name_translations: {
                    en: "Guernsey"
                }
            },
            {
                name: "Saint Lucia",
                currency: "XCD",
                code: "LC",
                name_translations: {
                    en: "Saint Lucia"
                }
            },
            {
                name: "Palau",
                currency: "USD",
                code: "PW",
                name_translations: {
                    en: "Palau"
                }
            },
            {
                name: "Uganda",
                currency: "UGX",
                code: "UG",
                name_translations: {
                    en: "Uganda"
                }
            },
            {
                name: "Fransız Guyanası",
                currency: "EUR",
                code: "GF",
                name_translations: {
                    en: "French Guiana"
                }
            },
            {
                name: "Mikronezya",
                currency: "USD",
                code: "FM",
                name_translations: {
                    en: "Micronesia"
                }
            },
            {
                name: "Aruba",
                currency: "AWG",
                code: "AW",
                name_translations: {
                    en: "Aruba"
                }
            },
            {
                name: "Timor-Leste",
                currency: "USD",
                code: "TL",
                name_translations: {
                    en: "East Timor"
                }
            },
            {
                name: "San Marino",
                currency: "EUR",
                code: "SM",
                name_translations: {
                    en: "San Marino"
                }
            },
            {
                name: "Portekiz",
                currency: "EUR",
                code: "PT",
                name_translations: {
                    en: "Portugal"
                }
            },
            {
                name: "Britanya Virjin Adaları",
                currency: "USD",
                code: "VG",
                name_translations: {
                    en: "British Virgin Islands"
                }
            },
            {
                name: "Kuzey Kore",
                currency: "KPW",
                code: "KP",
                name_translations: {
                    en: "North Korea"
                }
            },
            {
                name: "Umman",
                currency: "OMR",
                code: "OM",
                name_translations: {
                    en: "Oman"
                }
            },
            {
                name: "Moritanya",
                currency: "MRO",
                code: "MR",
                name_translations: {
                    en: "Mauritania"
                }
            },
            {
                name: "Anguilla",
                currency: "XCD",
                code: "AI",
                name_translations: {
                    en: "Anguilla"
                }
            },
            {
                name: "Saint Martin",
                currency: "EUR",
                code: "MF",
                name_translations: {
                    en: "Saint Martin"
                }
            },
            {
                name: "Güney Afrika",
                currency: "ZAR",
                code: "ZA",
                name_translations: {
                    en: "South Africa"
                }
            },
            {
                name: "Kosova",
                currency: "EUR",
                code: "XK",
                name_translations: {
                    en: "Kosovo"
                }
            },
            {
                name: "Polonya",
                currency: "PLN",
                code: "PL",
                name_translations: {
                    en: "Poland"
                }
            },
            {
                name: "Bahreyn",
                currency: "BHD",
                code: "BH",
                name_translations: {
                    en: "Bahrain"
                }
            },
            {
                name: "Malezya",
                currency: "MYR",
                code: "MY",
                name_translations: {
                    en: "Malaysia"
                }
            },
            {
                name: "Marshall Adaları",
                currency: "USD",
                code: "MH",
                name_translations: {
                    en: "Marshall Islands"
                }
            },
            {
                name: "South Georgia and the South Sandwich Islands",
                currency: "GBP",
                code: "GS",
                name_translations: {
                    en: "South Georgia and the South Sandwich Islands"
                }
            },
            {
                name: "Gambiya",
                currency: "GMD",
                code: "GM",
                name_translations: {
                    en: "Gambia"
                }
            },
            {
                name: "Trinidad ve Tobago",
                currency: "TTD",
                code: "TT",
                name_translations: {
                    en: "Trinidad and Tobago"
                }
            },
            {
                name: "Nijer",
                currency: "XOF",
                code: "NE",
                name_translations: {
                    en: "Niger"
                }
            },
            {
                name: "French Southern Territories",
                currency: "EUR",
                code: "TF",
                name_translations: {
                    en: "French Southern Territories"
                }
            },
            {
                name: "Guam",
                currency: "USD",
                code: "GU",
                name_translations: {
                    en: "Guam"
                }
            },
            {
                name: "Christmas Adası",
                currency: "AUD",
                code: "CX",
                name_translations: {
                    en: "Christmas Island"
                }
            },
            {
                name: "Irak",
                currency: "IQD",
                code: "IQ",
                name_translations: {
                    en: "Iraq"
                }
            },
            {
                name: "Bolivya",
                currency: "BOB",
                code: "BO",
                name_translations: {
                    en: "Bolivia"
                }
            },
            {
                name: "Arjantin",
                currency: "ARS",
                code: "AR",
                name_translations: {
                    en: "Argentina"
                }
            },
            {
                name: "Hindistan",
                currency: "INR",
                code: "IN",
                name_translations: {
                    en: "India"
                }
            },
            {
                name: "Türkmenistan",
                currency: "TMT",
                code: "TM",
                name_translations: {
                    en: "Turkmenistan"
                }
            },
            {
                name: "Burundi",
                currency: "BIF",
                code: "BI",
                name_translations: {
                    en: "Burundi"
                }
            },
            {
                name: "Özbekistan",
                currency: "UZS",
                code: "UZ",
                name_translations: {
                    en: "Uzbekistan"
                }
            },
            {
                name: "Venezuela",
                currency: "VEF",
                code: "VE",
                name_translations: {
                    en: "Venezuela"
                }
            },
            {
                name: "Kamerun",
                currency: "XAF",
                code: "CM",
                name_translations: {
                    en: "Cameroon"
                }
            },
            {
                name: "Mısır",
                currency: "EGP",
                code: "EG",
                name_translations: {
                    en: "Egypt"
                }
            },
            {
                name: "Man Adası",
                currency: "GBP",
                code: "IM",
                name_translations: {
                    en: "Isle of Man"
                }
            },
            {
                name: "Sint Maarten",
                currency: "ANG",
                code: "SX",
                name_translations: {
                    en: "Sint Maarten"
                }
            },
            {
                name: "Slovakya",
                currency: "EUR",
                code: "SK",
                name_translations: {
                    en: "Slovakia"
                }
            },
            {
                name: "İzlanda",
                currency: "ISK",
                code: "IS",
                name_translations: {
                    en: "Iceland"
                }
            },
            {
                name: "Tayland",
                currency: "THB",
                code: "TH",
                name_translations: {
                    en: "Thailand"
                }
            },
            {
                name: "Uruguay",
                currency: "UYU",
                code: "UY",
                name_translations: {
                    en: "Uruguay"
                }
            },
            {
                name: "Suriye",
                currency: "SYP",
                code: "SY",
                name_translations: {
                    en: "Syria"
                }
            },
            {
                name: "Svaziland",
                currency: "SZL",
                code: "SZ",
                name_translations: {
                    en: "Eswatini"
                }
            },
            {
                name: "Avustralya",
                currency: "AUD",
                code: "AU",
                name_translations: {
                    en: "Australia"
                }
            },
            {
                name: "Senegal",
                currency: "XOF",
                code: "SN",
                name_translations: {
                    en: "Senegal"
                }
            },
            {
                name: "Papua Yeni Gine",
                currency: "PGK",
                code: "PG",
                name_translations: {
                    en: "Papua New Guinea"
                }
            },
            {
                name: "Wallis ve Futuna Adaları",
                currency: "XPF",
                code: "WF",
                name_translations: {
                    en: "Wallis and Futuna"
                }
            },
            {
                name: "Danimarka",
                currency: "DKK",
                code: "DK",
                name_translations: {
                    en: "Denmark"
                }
            },
            {
                name: "Malavi",
                currency: "MWK",
                code: "MW",
                name_translations: {
                    en: "Malawi"
                }
            },
            {
                name: "Sudan",
                currency: "SDG",
                code: "SD",
                name_translations: {
                    en: "Sudan"
                }
            },
            {
                name: "Norveç",
                currency: "NOK",
                code: "NO",
                name_translations: {
                    en: "Norway"
                }
            },
            {
                name: "Romanya",
                currency: "RON",
                code: "RO",
                name_translations: {
                    en: "Romania"
                }
            },
            {
                name: "İsrail",
                currency: "ILS",
                code: "IL",
                name_translations: {
                    en: "Israel"
                }
            },
            {
                name: "Kuveyt",
                currency: "KWD",
                code: "KW",
                name_translations: {
                    en: "Kuwait"
                }
            },
            {
                name: "Filistin",
                currency: "ILS",
                code: "PS",
                name_translations: {
                    en: "Palestine"
                }
            },
            {
                name: "Zambiya",
                currency: "ZMK",
                code: "ZM",
                name_translations: {
                    en: "Zambia"
                }
            },
            {
                name: "Arnavutluk",
                currency: "ALL",
                code: "AL",
                name_translations: {
                    en: "Albania"
                }
            },
            {
                name: "Ekvator Ginesi",
                currency: "XAF",
                code: "GQ",
                name_translations: {
                    en: "Equatorial Guinea"
                }
            },
            {
                name: "Hollanda",
                currency: "EUR",
                code: "NL",
                name_translations: {
                    en: "Netherlands"
                }
            },
            {
                name: "İtalya",
                currency: "EUR",
                code: "IT",
                name_translations: {
                    en: "Italy"
                }
            },
            {
                name: "El Salvador",
                currency: "USD",
                code: "SV",
                name_translations: {
                    en: "El Salvador"
                }
            },
            {
                name: "Litvanya",
                currency: "LTL",
                code: "LT",
                name_translations: {
                    en: "Lithuania"
                }
            },
            {
                name: "Orta Afrika Cumhuriyeti",
                currency: "XAF",
                code: "CF",
                name_translations: {
                    en: "Central African Republic"
                }
            },
            {
                name: "Moğolistan",
                currency: "MNT",
                code: "MN",
                name_translations: {
                    en: "Mongolia"
                }
            },
            {
                name: "Kanada",
                currency: "CAD",
                code: "CA",
                name_translations: {
                    en: "Canada"
                }
            },
            {
                name: "Kırgızistan",
                currency: "KGS",
                code: "KG",
                name_translations: {
                    en: "Kyrgyzstan"
                }
            },
            {
                name: "Madagaskar",
                currency: "MGA",
                code: "MG",
                name_translations: {
                    en: "Madagascar"
                }
            },
            {
                name: "Libya",
                currency: "LYD",
                code: "LY",
                name_translations: {
                    en: "Libya"
                }
            },
            {
                name: "Kazakistan",
                currency: "KZT",
                code: "KZ",
                name_translations: {
                    en: "Kazakhstan"
                }
            },
            {
                name: "Kamboçya",
                currency: "KHR",
                code: "KH",
                name_translations: {
                    en: "Cambodia"
                }
            },
            {
                name: "Çad",
                currency: "XAF",
                code: "TD",
                name_translations: {
                    en: "Chad"
                }
            },
            {
                name: "Kenya",
                currency: "KES",
                code: "KE",
                name_translations: {
                    en: "Kenya"
                }
            },
            {
                name: "Letonya",
                currency: "LVL",
                code: "LV",
                name_translations: {
                    en: "Latvia"
                }
            },
            {
                name: "Togo",
                currency: "XOF",
                code: "TG",
                name_translations: {
                    en: "Togo"
                }
            },
            {
                name: "Surinam",
                currency: "SRD",
                code: "SR",
                name_translations: {
                    en: "Suriname"
                }
            },
            {
                name: "Ürdün",
                currency: "JOD",
                code: "JO",
                name_translations: {
                    en: "Jordan"
                }
            },
            {
                name: "Gürcistan",
                currency: "GEL",
                code: "GE",
                name_translations: {
                    en: "Georgia"
                }
            },
            {
                name: "Bahamalar",
                currency: "BSD",
                code: "BS",
                name_translations: {
                    en: "Bahamas"
                }
            },
            {
                name: "Avusturya",
                currency: "EUR",
                code: "AT",
                name_translations: {
                    en: "Austria"
                }
            },
            {
                name: "Endonezya",
                currency: "IDR",
                code: "ID",
                name_translations: {
                    en: "Indonesia"
                }
            },
            {
                name: "İsviçre",
                currency: "CHF",
                code: "CH",
                name_translations: {
                    en: "Switzerland"
                }
            },
            {
                name: "Makao",
                currency: "MOP",
                code: "MO",
                name_translations: {
                    en: "Macau"
                }
            },
            {
                name: "Nikaragua",
                currency: "NIO",
                code: "NI",
                name_translations: {
                    en: "Nicaragua"
                }
            },
            {
                name: "Tanzanya",
                currency: "TZS",
                code: "TZ",
                name_translations: {
                    en: "Tanzania"
                }
            },
            {
                name: "Maldivler",
                currency: "MVR",
                code: "MV",
                name_translations: {
                    en: "Maldives"
                }
            },
            {
                name: "Fransa",
                currency: "EUR",
                code: "FR",
                name_translations: {
                    en: "France"
                }
            },
            {
                name: "Cezayir",
                currency: "DZD",
                code: "DZ",
                name_translations: {
                    en: "Algeria"
                }
            },
            {
                name: "Yunanistan",
                currency: "EUR",
                code: "GR",
                name_translations: {
                    en: "Greece"
                }
            },
            {
                name: "Bulgaristan",
                currency: "BGN",
                code: "BG",
                name_translations: {
                    en: "Bulgaria"
                }
            },
            {
                name: "Burkina Faso",
                currency: "XOF",
                code: "BF",
                name_translations: {
                    en: "Burkina Faso"
                }
            },
            {
                name: "Belçika",
                currency: "EUR",
                code: "BE",
                name_translations: {
                    en: "Belgium"
                }
            },
            {
                name: "Fas",
                currency: "MAD",
                code: "MA",
                name_translations: {
                    en: "Morocco"
                }
            },
            {
                name: "Almanya",
                currency: "EUR",
                code: "DE",
                name_translations: {
                    en: "Germany"
                }
            },
            {
                name: "Angola",
                currency: "AOA",
                code: "AO",
                name_translations: {
                    en: "Angola"
                }
            },
            {
                name: "Yemen",
                currency: "YER",
                code: "YE",
                name_translations: {
                    en: "Yemen"
                }
            },
            {
                name: "Bosna Hersek",
                currency: "BAM",
                code: "BA",
                name_translations: {
                    en: "Bosnia and Herzegovina"
                }
            },
            {
                name: "Bangladeş",
                currency: "BDT",
                code: "BD",
                name_translations: {
                    en: "Bangladesh"
                }
            },
            {
                name: "Seyşeller",
                currency: "SCR",
                code: "SC",
                name_translations: {
                    en: "Seychelles"
                }
            },
            {
                name: "Fiji",
                currency: "FJD",
                code: "FJ",
                name_translations: {
                    en: "Fiji"
                }
            },
            {
                name: "Crimea",
                currency: null,
                code: "KX",
                name_translations: {
                    en: "Crimea"
                }
            },
            {
                name: "Honduras",
                currency: "HNL",
                code: "HN",
                name_translations: {
                    en: "Honduras"
                }
            },
            {
                name: "Tayvan",
                currency: "TWD",
                code: "TW",
                name_translations: {
                    en: "Taiwan"
                }
            },
            {
                name: "Tonga",
                currency: "TOP",
                code: "TO",
                name_translations: {
                    en: "Tonga"
                }
            },
            {
                name: "İran",
                currency: "IRR",
                code: "IR",
                name_translations: {
                    en: "Iran"
                }
            },
            {
                name: "São Tomé ve Príncipe",
                currency: "STD",
                code: "ST",
                name_translations: {
                    en: "São Tomé and Príncipe"
                }
            },
            {
                name: "Bermuda",
                currency: "BMD",
                code: "BM",
                name_translations: {
                    en: "Bermuda"
                }
            },
            {
                name: "Vanuatu",
                currency: "VUV",
                code: "VU",
                name_translations: {
                    en: "Vanuatu"
                }
            },
            {
                name: "Kiribati",
                currency: "AUD",
                code: "KI",
                name_translations: {
                    en: "Kiribati"
                }
            },
            {
                name: "Namibya",
                currency: "NAD",
                code: "NA",
                name_translations: {
                    en: "Namibia"
                }
            },
            {
                name: "Japonya",
                currency: "JPY",
                code: "JP",
                name_translations: {
                    en: "Japan"
                }
            },
            {
                name: "ABD Küçük Dış Adaları",
                currency: "USD",
                code: "UM",
                name_translations: {
                    en: "United States Minor Outlying Islands"
                }
            },
            {
                name: "Laos",
                currency: "LAK",
                code: "LA",
                name_translations: {
                    en: "Laos"
                }
            },
            {
                name: "ABD",
                currency: "USD",
                code: "US",
                name_translations: {
                    en: "United States"
                }
            },
            {
                name: "Yeni Zelanda",
                currency: "NZD",
                code: "NZ",
                name_translations: {
                    en: "New Zealand"
                }
            },
            {
                name: "Güney Sudan",
                currency: null,
                code: "SS",
                name_translations: {
                    en: "South Sudan"
                }
            },
            {
                name: "Hırvatistan",
                currency: "HRK",
                code: "HR",
                name_translations: {
                    en: "Croatia"
                }
            },
            {
                name: "Türkiye",
                currency: "TRY",
                code: "TR",
                name_translations: {
                    en: "Turkey"
                }
            },
            {
                name: "Karayip Hollanda",
                currency: "USD",
                code: "BQ",
                name_translations: {
                    en: "Caribbean Netherlands"
                }
            },
            {
                name: "Ukraine",
                currency: "UAH",
                code: "UA",
                name_translations: {
                    en: "Ukraine"
                }
            },
            {
                name: "Liberya",
                currency: "LRD",
                code: "LR",
                name_translations: {
                    en: "Liberia"
                }
            },
            {
                name: "Benin",
                currency: "XOF",
                code: "BJ",
                name_translations: {
                    en: "Benin"
                }
            },
            {
                name: "Sri Lanka",
                currency: "LKR",
                code: "LK",
                name_translations: {
                    en: "Sri Lanka"
                }
            },
            {
                name: "Tacikistan",
                currency: "TJS",
                code: "TJ",
                name_translations: {
                    en: "Tajikistan"
                }
            },
            {
                name: "Nepal",
                currency: "NPR",
                code: "NP",
                name_translations: {
                    en: "Nepal"
                }
            },
            {
                name: "Meksika",
                currency: "MXN",
                code: "MX",
                name_translations: {
                    en: "Mexico"
                }
            },
            {
                name: "Gine-Bissau",
                currency: "XOF",
                code: "GW",
                name_translations: {
                    en: "Guinea-Bissau"
                }
            }
        ]
    },

    cabins() {
        return [
            {
                name: 'Economy',
                value: 'Economy'
            },
            {
                name: 'Business',
                value: 'Business'
            },
            {
                name: 'Premium',
                value: 'Premium'
            },
            {
                name: 'First',
                value: 'First'
            },

        ]
    },
    ajetFares(){
    return {
        "BASIC": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
        },
        "ECOJET": {
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
        },
        "FLEX": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
        },
        "PREMIUM": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
        },
      }
    },
     pegasusFares(){ 
        return {
        "LIGHT": {
          domestic: {
            features: [

            ],
          },
          international: {
            features: [
            ],
          },
        },
        "SÜPER EKO": {
          domestic: {
            features: [
            ],
          },
          international: {
            features: [
            ],
          },
          cyprus: {
            features: [
            ],
          },
        },
        "AVANTAJ": {
          domestic: {
            features: [
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
        },
        "COMFORT FLEX": {
          domestic: {
            features: [
              "Dilediğiniz Koltuk Seçimi",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "Dilediğiniz Koltuk Seçimi",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
        },
      }
    }
}